/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Create_TitleInputs */

const en_admin_roles_create_title = /** @type {(inputs: Admin_Roles_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create New Role`)
};

/**
* | output |
* | --- |
* | "Create New Role" |
*
* @param {Admin_Roles_Create_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_create_title = /** @type {((inputs?: Admin_Roles_Create_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Create_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_create_title(inputs)
});
export { admin_roles_create_title as "admin.roles.create_title" }